





























helpers = require('../../helpers.coffee')

view_model =
  props: ['template']

  data: ->
    current_user: Session.current_user
  
  computed:
    editPath: ->
      "/templates/#{@template.id}/editar"

exports.default = view_model



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/show_modal.vue